module.exports = __webpack_public_path__ + "img/ji.ce5bc445.jpg";